import { render } from "./isturForm.vue?vue&type=template&id=6a1520d8"
import script from "./isturForm.vue?vue&type=script&lang=js"
export * from "./isturForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__